var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"color":_vm.dialogColor,"dark":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }